import { SyncActionFactory } from 'app/shared/utils/redux/sync.actions'
import { State } from '../state'

export class DateTimeFormatsSettingsActions {
  public static setDateTimeFormatsSettings = new SyncActionFactory<
    State['dateTimeFormats']
  >('[DATE TIME FORMATS] SET DATE TIME FORMATS SETTINGS')
}
